import { render, staticRenderFns } from "./UserContacts.vue?vue&type=template&id=1036a03c&scoped=true"
import script from "./UserContacts.vue?vue&type=script&lang=ts"
export * from "./UserContacts.vue?vue&type=script&lang=ts"
import style0 from "./UserContacts.vue?vue&type=style&index=0&id=1036a03c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1036a03c",
  null
  
)

export default component.exports